module.exports = __webpack_public_path__ + "img/show_more.991e049c.svg";